<template>

    <v-page-widget>
        <template #body>
            <v-stats size="sm" :stats="stats" />
        </template>
    </v-page-widget>

</template>

<style scoped lang="scss">

</style>

<script>

import CurrencyUtil from '@utils/CurrencyUtil';
import numeral from 'numeral';

export default {

    props: {
        customer: {
            type: Object,
            required: true,
        }
    },

    computed: {

        summary() {
            return this.customer.charge_summary || {
                sum: 0,
                count: 0,
            };
        },

        stats() {
            return [
                {
                    label: 'Charges',
                    value: numeral(this.summary.count).format('0,0'),
                    route: { name: 'customer-charges', params: { id: this.customer.id } },
                },
                {
                    label: 'Revenue',
                    value: CurrencyUtil.format(this.summary.sum / 100),
                },
            ];
        },

    },

}

</script>
